export const environment = {
  production: true,
  useLegacyLogin: false,
  apiPrefix: '/api/v0',
  productionClientId: '9ce190ac-d998-4b95-87cb-78ce48134502',
  developmentClientId: '53903b6b-7123-42a5-a8fa-3b3e068c4cad',
};
